import { useEffect } from 'react';
import GVSelect from 'components/lib/GVSelect/GVSelect';
import { useCTFVersion } from 'pages/InternalPage/ctfVersionStore';
import styles from './CTFVersionSelector.module.css';

const CTFVersionSelector = () => {
  const { availableVersions, versionOverride, overrideVersion, fetchAvailableVersions, fetchVersionOverrides } =
    useCTFVersion();

  useEffect(() => {
    fetchAvailableVersions();
    fetchVersionOverrides();
  }, []);

  const selectedVersion = availableVersions.find((version) => version === versionOverride) ?? null;

  if (!availableVersions.length) return null;

  const options = availableVersions.map((version) => ({
    label: version,
    value: version,
  }));

  return (
    <div className={styles.container} data-testid="ctf-version-selector">
      <span className={styles.label}>CTF Version:</span>
      <GVSelect
        id="ctf-version-dropdown"
        label="CTF Version"
        isLabelHidden
        value={selectedVersion}
        onValueChange={overrideVersion}
        options={options}
        className={styles.select}
        contentClassName={styles.panel}
      />
    </div>
  );
};

export default CTFVersionSelector;
